import React from 'react';

const stack = [
  { name: 'Java Spring', role: 'Backend core', layer: 'Backend' },
  { name: 'Laravel', role: 'App layer', layer: 'Backend' },
  { name: 'React', role: 'Agent UI', layer: 'Frontend' },
  { name: 'RabbitMQ', role: 'Message queue', layer: 'Messaging' },
  { name: 'PostgreSQL', role: 'Primary DB', layer: 'Data' },
  { name: 'MySQL', role: 'Secondary DB', layer: 'Data' },
];

const integrations = ['Salesforce', 'Calabrio', 'Custom CRM', 'Lead suppliers', 'REST API', 'Webhooks', 'WhatsApp Business', 'Jira'];

export default function TechStack() {
  return (
    <section id="integrations" style={{ maxWidth: 960, margin: '0 auto', padding: '5rem 2.5rem' }}>
      <div style={tag}>// INTEGRATIONS</div>
      <h2 style={head}>Connects to <span style={{ color: '#0a9e8f' }}>your stack.</span></h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: '1.75rem' }}>
        {integrations.map((int, i) => (
          <div key={i} style={{ background: '#0a0a0a', border: '1px solid rgba(10,158,143,0.13)', padding: '0.6rem 1rem', borderRadius: 7, fontSize: '0.8rem', color: '#c0c0c0', fontFamily: "'JetBrains Mono', monospace", transition: 'border-color .2s, color .2s', cursor: 'default' }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(10,158,143,0.4)'; e.currentTarget.style.color = '#0a9e8f'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(10,158,143,0.13)'; e.currentTarget.style.color = '#c0c0c0'; }}>
            {int}
          </div>
        ))}
      </div>
      <div style={{ marginTop: '1.5rem', padding: '1rem 1.25rem', background: 'rgba(10,158,143,0.06)', border: '1px solid rgba(10,158,143,0.2)', borderRadius: 8, maxWidth: 480 }}>
        <div style={{ fontSize: '0.72rem', color: '#0a9e8f', fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.06em', marginBottom: 6 }}>ARCHITECTURE</div>
        <div style={{ fontSize: '0.8125rem', color: '#c0c0c0', fontWeight: 300, lineHeight: 1.6 }}>Microservices · API-first · Agile-built · Horizontally scalable</div>
      </div>
    </section>
  );
}

const tag = { fontSize: '0.68rem', color: '#077a6e', fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.1em', marginBottom: 12, borderLeft: '2px solid #056055', paddingLeft: 10 };
const head = { fontSize: 'clamp(1.4rem,2.5vw,1.9rem)', fontWeight: 700, letterSpacing: '-0.03em', color: '#f0f0f0', lineHeight: 1.2 };
